var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"49acead788d1c971daa5c725cc2fb03eb195366b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["myody-vue@kompeito"]={id:"49acead788d1c971daa5c725cc2fb03eb195366b"};
      